




































import {focusNextElement, PlainObject} from '@labor-digital/helferlein';
import {Component, Vue} from 'vue-property-decorator';
import VuDropdownTriggerAbstract from './VuDropdownTriggerAbstract.vue';

@Component
export default class VuDropdownTriggerTemplate extends Vue
{
    get p(): VuDropdownTriggerAbstract
    {
        return this.$parent as any;
    }

    get attr(): PlainObject
    {
        return {
            href: this.p.tag === 'a' ? '#' : null
        };
    }

    public onKeyUp(e: KeyboardEvent): void
    {
        if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
            if (!this.p.api.isOpen) {
                this.p.toggle();
            }
            this.$nextTick(() => {
                focusNextElement(this.$el as HTMLElement);
            });
        }
    }

    public onKeyDown(e: KeyboardEvent): void
    {
        if (e.code === 'ArrowDown' || e.code === 'ArrowUp') {
            e.stopPropagation();
            e.preventDefault();
        }
    }
}
